import { useEffect, useMemo, useState } from "react";
import { StudentLayout } from "@/components/Layouts";
import { NoteCard } from "@/components/NoteCard";
import { EmptyState } from "@/components/EmptyState";
import { FileText, Folder } from "lucide-react";
import api from "@/lib/api";

export default function StudentNotes() {
  const [notes, setNotes] = useState([]);
  useEffect(() => {
    api.get("/notes").then((r) => setNotes(r.data)).catch(() => {});
  }, []);

  // Group notes by folder_name (empty folder = "Module Utama")
  const grouped = useMemo(() => {
    const buckets = new Map();
    for (const n of notes) {
      const key = n.folder_name?.trim() || "";
      if (!buckets.has(key)) buckets.set(key, []);
      buckets.get(key).push(n);
    }
    // Default group first (no folder), then named folders alphabetically
    const sorted = Array.from(buckets.entries()).sort((a, b) => {
      if (a[0] === "" && b[0] !== "") return -1;
      if (b[0] === "" && a[0] !== "") return 1;
      return a[0].localeCompare(b[0]);
    });
    return sorted;
  }, [notes]);

  return (
    <StudentLayout title="Class Notes">
      <div className="mb-5">
        <h1 className="text-3xl font-heading font-bold tracking-tight">Class Notes</h1>
        <p className="mt-2 text-muted-foreground">Download class notes by available module.</p>
      </div>

      {notes.length === 0 ? (
        <EmptyState icon={FileText} title="Notes not yet available." description="Notes are not yet available for download. Please semak semula kemudian." />
      ) : (
        <div className="space-y-8">
          {grouped.map(([folder, list]) => (
            <section key={folder || "main"}>
              {folder && (
                <h2 className="flex items-center gap-2 text-sm font-heading font-semibold text-muted-foreground uppercase tracking-wider mb-3">
                  <Folder className="h-4 w-4" /> {folder}
                  <span className="text-xs text-muted-foreground/70 normal-case font-normal">· {list.length} nota</span>
                </h2>
              )}
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {list.map((n) => <NoteCard key={n.id} note={n} />)}
              </div>
            </section>
          ))}
        </div>
      )}
    </StudentLayout>
  );
}
